export const toggleSetItem = (items: Set<string>, key: string, isExpanded: boolean): Set<string> => {
    const next = new Set(items);
    if (isExpanded) {
        next.add(key);
    } else {
        next.delete(key);
    }
    return next;
};
